import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getStoredToken } from '../services/authService';
import { isPublicResumePathname } from '../utils/routeAccess';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const token = getStoredToken();
  if (!token && !isPublicResumePathname(location.pathname)) {
    const next = `${location.pathname}${location.search}${location.hash}`;
    return (
      <Navigate
        to="/resume/contractor"
        replace
        state={{ openAuthModalFor: next }}
      />
    );
  }
  return children;
}
